module.exports = __webpack_public_path__ + "static/media/comment_collan.9a21d285.svg";